import axios from "@/api/axios"
import {apiUrlWithLang} from "@/helpers/persistanceStorage";

const createRecipient = credentials => {
    let url = apiUrlWithLang('/dashboard/api/recipient/update')
    return axios.post(url, credentials)
}

const updateRecipient = credentials => {
    let url = apiUrlWithLang('/dashboard/api/recipient/update')
    return axios.post(url, credentials)
}

const getRecipients = credentials => {
    let url = apiUrlWithLang('/dashboard/api/recipients?_order_by=created')
    return axios.get(url, { params:credentials })
}

const removeRecipient = credentials => {
    let url = apiUrlWithLang('/dashboard/api/recipient/delete')
    return axios.delete(url, {data: credentials})
}
export default {
    getRecipients,
    removeRecipient,
    createRecipient,
    updateRecipient
}